import { string, object } from 'yup';

const loginValidationSchema = object().shape({
  email: string().email('INVALID_EMAIL').required('REQUIRED'),
  password: string().min(6, 'SHORT_PASSWORD').required('REQUIRED'),
});

export default loginValidationSchema;
